import { createApiRequest } from "@/lib/api/createApiService";
import { ROLES_PERMISSIONS_ENDPOINTS } from "./roles-permissions.endpoints";

export const rolesPermissionsService = {
  listModules: async (params = {}, options = {}) => {
    return createApiRequest({
      url: ROLES_PERMISSIONS_ENDPOINTS.LIST_MODULES,
      method: "GET",
      body: params,
      ...options,
    });
  },

  listRoles: async (options = {}) => {
    return createApiRequest({
      url: ROLES_PERMISSIONS_ENDPOINTS.ROLES,
      method: "GET",
      ...options,
    });
  },

  createRole: async (payload, options = {}) => {
    return createApiRequest({
      url: ROLES_PERMISSIONS_ENDPOINTS.ROLES,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  updateRole: async (roleId, payload, options = {}) => {
    if (!roleId) throw new Error("roleId is required");
    return createApiRequest({
      url: ROLES_PERMISSIONS_ENDPOINTS.ROLE(roleId),
      method: "PATCH",
      body: payload,
      ...options,
    });
  },

  deleteRole: async (roleId, options = {}) => {
    if (!roleId) throw new Error("roleId is required");
    return createApiRequest({
      url: ROLES_PERMISSIONS_ENDPOINTS.ROLE(roleId),
      method: "DELETE",
      ...options,
    });
  },
};
